import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ContainerStationReducedFragmentDoc } from '../fragments/containerStationReduced.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreContainerStationsPaginatedQueryVariables = Types.Exact<{
  store_id: Types.Scalars['ID'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type StoreContainerStationsPaginatedQuery = { __typename?: 'Query', storeContainerStationsPaginated?: { __typename?: 'ContainerStationPaginatedResponse', total: number, container_stations: Array<{ __typename?: 'ContainerStation', id: string, name: string, store_id: string, status?: Types.ContainerStationStatus | null, epc_tag: string, total_stock: number, item_location_name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null, archived: boolean, weight: number }, store: { __typename?: 'Store', id: string, name?: string | null, brand_id?: string | null }, current_item_location?: { __typename?: 'ContainerStationItemLocationInfo', name: string } | null, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, image_url?: string | null, sealed: boolean }> }> } | null };


export const StoreContainerStationsPaginatedDocument = gql`
    query StoreContainerStationsPaginated($store_id: ID!, $skip: Int!, $take: Int!) {
  storeContainerStationsPaginated(store_id: $store_id, skip: $skip, take: $take) {
    total
    container_stations {
      ...ContainerStationReduced
    }
  }
}
    ${ContainerStationReducedFragmentDoc}`;

/**
 * __useStoreContainerStationsPaginatedQuery__
 *
 * To run a query within a React component, call `useStoreContainerStationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreContainerStationsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreContainerStationsPaginatedQuery({
 *   variables: {
 *      store_id: // value for 'store_id'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useStoreContainerStationsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<StoreContainerStationsPaginatedQuery, StoreContainerStationsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreContainerStationsPaginatedQuery, StoreContainerStationsPaginatedQueryVariables>(StoreContainerStationsPaginatedDocument, options);
      }
export function useStoreContainerStationsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreContainerStationsPaginatedQuery, StoreContainerStationsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreContainerStationsPaginatedQuery, StoreContainerStationsPaginatedQueryVariables>(StoreContainerStationsPaginatedDocument, options);
        }
export type StoreContainerStationsPaginatedQueryHookResult = ReturnType<typeof useStoreContainerStationsPaginatedQuery>;
export type StoreContainerStationsPaginatedLazyQueryHookResult = ReturnType<typeof useStoreContainerStationsPaginatedLazyQuery>;
export type StoreContainerStationsPaginatedQueryResult = Apollo.QueryResult<StoreContainerStationsPaginatedQuery, StoreContainerStationsPaginatedQueryVariables>;